<template>
  <div class="main-content">
    <div class="page-header">
      <h3 class="page-title">IcoMoon</h3>
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a href="#">Home</a></li>
        <li class="breadcrumb-item"><a href="#">Icons</a></li>
        <li class="breadcrumb-item"><a href="#">IcoMoon</a></li>
      </ol>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            <h6>Example Usage</h6>
          </div>
          <div class="card-body">
            <pre class="language-html"><code>&lt;i class="icon-im icon-im-home"&gt;&lt;/i&gt;</code></pre>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <div class="icon-container">
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-home"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-home, <br>icon-im-house</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-home2"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-home2, <br>icon-im-house2</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-home3"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-home3, <br>icon-im-house3</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-office"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-office, <br>icon-im-buildings</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-newspaper"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-newspaper, <br>icon-im-news</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-pencil"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-pencil, <br>icon-im-write</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-pencil2"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-pencil2, <br>icon-im-write2</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-quill"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-quill, <br>icon-im-feather</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-pen"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-pen, <br>icon-im-write3</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-blog"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-blog, <br>icon-im-pen2</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-eyedropper"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-eyedropper, <br>icon-im-color</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-droplet"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-droplet, <br>icon-im-color2</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-paint-format"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-paint-format, <br>icon-im-format</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-image"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-image, <br>icon-im-picture</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-images"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-images, <br>icon-im-pictures</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-camera"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-camera, <br>icon-im-photo</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-headphones"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-headphones, <br>icon-im-headset</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-music"/>
                </div>
                <div class="icon-classname">
                  <span>icon-music, <br>icon-im-song</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-play"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-play, <br>icon-im-video</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-film"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-film, <br>icon-im-video2</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-video-camera"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-video-camera, <br>icon-im-video3</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-dice"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-dice, <br>icon-im-game</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-pacman"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-pacman, <br>icon-im-game2</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-spades"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-spades, <br>icon-im-cards</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-clubs"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-clubs, <br>icon-im-cards2</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-diamonds"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-diamonds, <br>icon-im-cards3</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-bullhorn"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-bullhorn, <br>icon-im-megaphone</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-connection"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-connection, <br>icon-im-wifi</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-podcast"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-podcast, <br>icon-im-broadcast</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-feed"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-feed, <br>icon-im-wave</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-mic"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-mic, <br>icon-im-microphone</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-book"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-book, <br>icon-im-read</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-books"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-books, <br>icon-im-library</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-library"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-library2, <br>icon-im-bank</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-file-text"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-file-text, <br>icon-im-file</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-profile"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-profile, <br>icon-im-file2</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-file-empty"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-file-empty, <br>icon-im-file3</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-files-empty"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-files-empty, <br>icon-im-files</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-file-text2"/>
                </div>
                <div class="icon-classname">
                  <span class="unit1">icon-file-text2, <br>icon-im-file4</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-file-picture"/>
                </div>
                <div class="icon-classname">
                  <span class="unit1">e927</span>
                  <span>icon-im-file-picture, <br>icon-im-file5</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-file-music"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-file-music, <br>icon-im-file6</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-file-play"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-file-play, <br>icon-im-file7</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-file-video"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-file-video, <br>icon-im-file8</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-file-zip"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-file-zip, <br>icon-im-file9</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-copy"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-copy, <br>icon-im-duplicate</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-paste"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-paste, <br>icon-im-clipboard-file</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-stack"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-stack, <br>icon-im-layers</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-folder"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-folder, <br>icon-im-directory</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-folder-open"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-folder-open, <br>icon-im-directory2</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-folder-plus"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-folder-plus, <br>icon-im-directory3</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-folder-minus"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-folder-minus, <br>icon-im-directory4</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-folder-download"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-folder-download, <br>icon-im-directory5</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-folder-upload"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-folder-upload, <br>icon-im-directory6</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-price-tag"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-price-tag</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-price-tags"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-price-tags</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-barcode"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-barcode</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-qrcode"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-qrcode</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-ticket"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-ticket, <br>icon-im-theater</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-cart"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-cart, <br>icon-im-purchase</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-coin-dollar"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-coin-dollar, <br>icon-im-money</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-coin-euro"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-coin-euro, <br>icon-im-money2</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-coin-pound"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-coin-pound, <br>icon-im-money3</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-coin-yen"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-coin-yen, <br>icon-im-money4</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-credit-card"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-credit-card, <br>icon-im-money5</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-calculator"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-calculator, <br>icon-im-compute</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-lifebuoy"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-lifebuoy, <br>icon-im-support</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-phone"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-phone, <br>icon-im-telephone</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-phone-hang-up"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-phone-hang-up, <br>icon-im-telephone2</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-address-book"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-address-book, <br>icon-im-contact</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-envelop"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-envelop, <br>icon-im-mail</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-pushpin"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-pushpin, <br>icon-im-pin</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-location"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-location, <br>icon-im-map-marker</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-location2"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-location2, <br>icon-im-map-marker2</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-compass"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-compass, <br>icon-im-direction</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-compass2"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-compass2, <br>icon-im-direction2</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-map"/>
                </div>
                <div class="icon-classname">
                  <span>icon-map, <br>icon-im-guide</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-map2"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-map2, <br>icon-im-guide2</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-history"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-history, <br>icon-im-time</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-clock"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-clock, <br>icon-im-time2</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-clock2"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-clock2, <br>icon-im-time3</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-alarm"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-alarm, <br>icon-im-time4</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-bell"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-bell, <br>icon-im-alarm2</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-stopwatch"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-stopwatch, <br>icon-im-time5</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-calendar"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-calendar, <br>icon-im-date</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-printer"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-printer, <br>icon-im-print</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-keyboard"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-keyboard, <br>icon-im-typing</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-display"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-display, <br>icon-im-screen</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-laptop"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-laptop, <br>icon-im-computer</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-mobile"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-mobile, <br>icon-im-cell-phone</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-mobile2"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-mobile2, <br>icon-im-cell-phone2</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-tablet"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-tablet, <br>icon-im-mobile3</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-tv"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-tv, <br>icon-im-television</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-drawer"/>
                </div>
                <div class="icon-classname">
                  <span>icon-drawer, <br>icon-im-box</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-drawer2"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-drawer2, <br>icon-im-box2</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-box-add"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-box-add, <br>icon-im-box3</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-box-remove"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-box-remove, <br>icon-im-box4</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-download"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-download, <br>icon-im-save</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-upload"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-upload, <br>icon-im-load</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-floppy-disk"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-floppy-disk, <br>icon-im-save2</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-drive"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-drive, <br>icon-im-save3</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-database"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-database, <br>icon-im-db</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-undo"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-undo, <br>icon-im-ccw</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-redo"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-redo, <br>icon-im-cw</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-undo2"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-undo2, <br>icon-im-left</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-redo2"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-redo2, <br>icon-im-right</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-forward"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-forward, <br>icon-im-right2</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-reply"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-reply, <br>icon-im-left2</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-bubble"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-bubble, <br>icon-im-comment</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-bubbles"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-bubbles, <br>icon-im-comments</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-bubbles2"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-bubbles2, <br>icon-im-comments2</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-bubble2"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-bubble2, <br>icon-im-comment2</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-bubbles3"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-bubbles3, <br>icon-im-comments3</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-bubbles4"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-bubbles4, <br>icon-im-comments4</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-user"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-user, <br>icon-im-profile2</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-users"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-users, <br>icon-im-group</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-user-plus"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-user-plus, <br>icon-im-user2</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-user-minus"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-user-minus, <br>icon-im-user3</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-user-check"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-user-check, <br>icon-im-user4</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-user-tie"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-user-tie, <br>icon-im-user5</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-quotes-left"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-quotes-left, <br>icon-im-ldquo</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-quotes-right"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-quotes-right, <br>icon-im-rdquo</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-hour-glass"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-hour-glass, <br>icon-im-loading</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-spinner"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-spinner, <br>icon-im-loading2</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-spinner2"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-spinner2, <br>icon-im-loading3</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-spinner3"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-spinner3, <br>icon-im-loading4</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-spinner4"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-spinner4, <br>icon-im-loading5</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-spinner5"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-spinner5, <br>icon-im-loading6</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-spinner6"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-spinner6, <br>icon-im-loading7</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-spinner7"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-spinner7, <br>icon-im-loading8</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-spinner8"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-spinner8, <br>icon-im-loading9</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-spinner9"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-spinner9, <br>icon-im-loading10</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-spinner10"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-spinner10, <br>icon-im-loading11</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-spinner11"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-spinner11, <br>icon-im-loading12</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-binoculars"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-binoculars, <br>icon-im-lookup</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-search"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-search, <br>icon-im-magnifier</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-zoom-in"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-zoom-in, <br>icon-im-magnifier2</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-zoom-out"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-zoom-out, <br>icon-im-magnifier3</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-enlarge"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-enlarge, <br>icon-im-expand</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-shrink"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-shrink, <br>icon-im-collapse</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-enlarge2"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-enlarge2, <br>icon-im-expand2</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-shrink2"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-shrink2, <br>icon-im-collapse2</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-key"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-key, <br>icon-im-password</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-key2"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-key2, <br>icon-im-password2</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-lock"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-lock, <br>icon-im-secure</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-unlocked"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-unlocked, <br>icon-im-lock-open</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-wrench"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-wrench, <br>icon-im-tool</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-equalizer"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-equalizer, <br>icon-im-sliders</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-equalizer2"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-equalizer2, <br>icon-im-sliders2</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-cog"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-cog, <br>icon-im-gear</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-cogs"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-cogs, <br>icon-im-gears</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-hammer"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-hammer, <br>icon-im-tool2</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-magic-wand"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-magic-wand, <br>icon-im-wizard</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-aid-kit"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-aid-kit, <br>icon-im-health</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-bug"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-bug, <br>icon-im-virus</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-pie-chart"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-pie-chart, <br>icon-im-stats</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-stats-dots"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-stats-dots, <br>icon-im-stats2</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-stats-bars"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-stats-bars, <br>icon-im-stats3</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-stats-bars2"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-stats-bars2, <br>icon-im-stats4</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-trophy"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-trophy, <br>icon-im-cup</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-gift"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-gift, <br>icon-im-present</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-glass"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-glass, <br>icon-im-drink</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-glass2"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-glass2, <br>icon-im-drink2</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-mug"/>
                </div>
                <div class="icon-classname">
                  <span>icon-mug, <br>icon-im-drink3</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-spoon-knife"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-spoon-knife, <br>icon-im-food</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-leaf"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-leaf, <br>icon-im-nature</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-rocket"/>
                </div>
                <div class="icon-classname">
                  <span>icon-rocket, <br>icon-im-jet</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-meter"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-meter, <br>icon-im-gauge</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-meter2"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-meter2, <br>icon-im-gauge2</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-hammer2"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-hammer2, <br>icon-im-gavel</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-fire"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-fire, <br>icon-im-flame</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-lab"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-lab, <br>icon-im-beta</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-magnet"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-magnet, <br>icon-im-attract</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-bin"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-bin, <br>icon-im-trashcan</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-bin2"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-bin2, <br>icon-im-trashcan2</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-briefcase"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-briefcase, <br>icon-im-portfolio</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-airplane"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-airplane, <br>icon-im-travel</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-truck"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-truck, <br>icon-im-transit</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-road"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-road, <br>icon-im-asphalt</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-accessibility"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-accessibility</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-target"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-target, <br>icon-im-goal</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-shield"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-shield, <br>icon-im-security</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-power"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-power, <br>icon-im-lightning</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-switch"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-switch</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-power-cord"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-power-cord, <br>icon-im-plugin</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-clipboard"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-clipboard, <br>icon-im-board</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-list-numbered"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-list-numbered, <br>icon-im-options</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-list"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-list, <br>icon-im-todo</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-list2"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-list2, <br>icon-im-todo2</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-tree"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-tree, <br>icon-im-branches</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-menu"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-menu, <br>icon-im-list3</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-menu2"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-menu2, <br>icon-im-options2</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-menu3"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-menu3, <br>icon-im-options3</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-menu4"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-menu4, <br>icon-im-options4</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-cloud"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-cloud, <br>icon-im-weather</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-cloud-download"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-cloud-download, <br>icon-im-cloud2</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-cloud-upload"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-cloud-upload, <br>icon-im-cloud3</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-cloud-check"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-cloud-check, <br>icon-im-cloud4</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-download2"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-download2, <br>icon-im-save4</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-upload2"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-upload2, <br>icon-im-load2</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-download3"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-download3, <br>icon-im-save5</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-upload3"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-upload3, <br>icon-im-load3</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-sphere"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-sphere, <br>icon-im-globe</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-earth"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-earth, <br>icon-im-globe2</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-link"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-link, <br>icon-im-chain</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-flag"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-flag, <br>icon-im-report</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-attachment"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-attachment, <br>icon-im-paperclip</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-eye"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-eye, <br>icon-im-views</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-eye-plus"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-eye-plus, <br>icon-im-views2</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-eye-minus"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-eye-minus, <br>icon-im-views3</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-eye-blocked"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-eye-blocked, <br>icon-im-views4</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-bookmark"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-bookmark, <br>icon-im-ribbon</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-bookmarks"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-bookmarks, <br>icon-im-ribbons</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-sun"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-sun, <br>icon-im-weather2</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-contrast"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-contrast</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-brightness-contrast"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-brightness-contrast</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-star-empty"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-star-empty, <br>icon-im-rate</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-star-half"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-star-half, <br>icon-im-rate2</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-star-full"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-star-full, <br>icon-im-rate3</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-heart"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-heart, <br>icon-im-like</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-heart-broken"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-heart-broken, <br>icon-im-heart2</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-man"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-man, <br>icon-im-male</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-woman"/>
                </div>
                <div class="icon-classname">
                  <span class="unit1">e9dd</span>
                  <span>icon-im-woman, <br>icon-im-female</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-man-woman"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-man-woman, <br>icon-im-toilet</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-happy"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-happy, <br>icon-im-emoticon</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-happy2"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-happy2, <br>icon-im-emoticon2</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-smile"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-smile, <br>icon-im-emoticon3</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-smile2"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-smile2, <br>icon-im-emoticon4</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-tongue"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-tongue, <br>icon-im-emoticon5</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-tongue2"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-tongue2, <br>icon-im-emoticon6</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-sad"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-sad, <br>icon-im-emoticon7</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-sad2"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-sad2, <br>icon-im-emoticon8</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-wink"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-wink, <br>icon-im-emoticon9</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-wink2"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-wink2, <br>icon-im-emoticon10</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-grin"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-grin, <br>icon-im-emoticon11</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-grin2"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-grin2, <br>icon-im-emoticon12</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-cool"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-cool, <br>icon-im-emoticon13</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-cool2"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-cool2, <br>icon-im-emoticon14</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-angry"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-angry, <br>icon-im-emoticon15</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-angry2"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-angry2, <br>icon-im-emoticon16</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-evil"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-evil, <br>icon-im-emoticon17</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-evil2"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-evil2, <br>icon-im-emoticon18</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-shocked"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-shocked, <br>icon-im-emoticon19</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-shocked2"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-shocked2, <br>icon-im-emoticon20</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-baffled"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-baffled, <br>icon-im-emoticon21</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-baffled2"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-baffled2, <br>icon-im-emoticon22</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-confused"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-confused, <br>icon-im-emoticon23</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-confused2"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-confused2, <br>icon-im-emoticon24</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-neutral"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-neutral, <br>icon-im-emoticon25</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-neutral2"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-neutral2, <br>icon-im-emoticon26</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-hipster"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-hipster, <br>icon-im-emoticon27</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-hipster2"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-hipster2, <br>icon-im-emoticon28</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-wondering"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-wondering, <br>icon-im-emoticon29</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-wondering2"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-wondering2, <br>icon-im-emoticon30</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-sleepy"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-sleepy, <br>icon-im-emoticon31</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-sleepy2"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-sleepy2, <br>icon-im-emoticon32</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-frustrated"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-frustrated, <br>icon-im-emoticon33</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-frustrated2"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-frustrated2, <br>icon-im-emoticon34</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-crying"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-crying, <br>icon-im-emoticon35</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-crying2"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-crying2, <br>icon-im-emoticon36</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-point-up"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-point-up, <br>icon-im-finger</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-point-right"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-point-right, <br>icon-im-finger2</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-point-down"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-point-down, <br>icon-im-finger3</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-point-left"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-point-left, <br>icon-im-finger4</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-warning"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-warning, <br>icon-im-sign</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-notification"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-notification, <br>icon-im-warning2</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-question"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-question, <br>icon-im-help</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-plus"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-plus, <br>icon-im-add</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-minus"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-minus, <br>icon-im-subtract</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-info"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-info, <br>icon-im-information</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-cancel-circle"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-cancel-circle, <br>icon-im-close</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-blocked"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-blocked, <br>icon-im-forbidden</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-cross"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-cross, <br>icon-im-cancel</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-checkmark"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-checkmark, <br>icon-im-tick</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-checkmark2"/>
                </div>
                <div class="icon-classname">
                  <span class="unit1">ea11</span>
                  <span>icon-im-checkmark2, <br>icon-im-tick2</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-spell-check"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-spell-check, <br>icon-im-spelling</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-enter"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-enter, <br>icon-im-signin</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-exit"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-exit, <br>icon-im-signout</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-play2"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-play2, <br>icon-im-player</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-pause"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-pause, <br>icon-im-player2</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-stop"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-stop, <br>icon-im-player3</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-previous"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-previous, <br>icon-im-player4</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-next"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-next, <br>icon-im-player5</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-backward"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-backward, <br>icon-im-player6</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-forward2"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-forward2, <br>icon-im-player7</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-play3"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-play3, <br>icon-im-player8</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-pause2"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-pause2, <br>icon-im-player9</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-stop2"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-stop2, <br>icon-im-player10</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-backward2"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-backward2, <br>icon-im-player11</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-forward3"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-forward3, <br>icon-im-player12</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-first"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-first, <br>icon-im-player13</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-last"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-last, <br>icon-im-player14</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-previous2"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-previous2, <br>icon-im-player15</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-next2"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-next2, <br>icon-im-player16</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-eject"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-eject, <br>icon-im-player17</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-volume-high"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-volume-high, <br>icon-im-volume</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-volume-medium"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-volume-medium, <br>icon-im-volume2</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-volume-low"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-volume-low, <br>icon-im-volume3</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-volume-mute"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-volume-mute, <br>icon-im-volume4</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-volume-mute2"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-volume-mute2, <br>icon-im-volume5</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-volume-increase"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-volume-increase, <br>icon-im-volume6</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-volume-decrease"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-volume-decrease, <br>icon-im-volume7</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-loop"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-loop, <br>icon-im-repeat</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-loop2"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-loop2, <br>icon-im-repeat2</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-infinite"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-infinite</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-shuffle"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-shuffle, <br>icon-im-random</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-arrow-up-left"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-arrow-up-left, <br>icon-im-up-left</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-arrow-up"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-arrow-up, <br>icon-im-up</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-arrow-up-right"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-arrow-up-right, <br>icon-im-up-right</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-arrow-right"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-arrow-right, <br>icon-im-right3</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-arrow-down-right"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-arrow-down-right, <br>icon-im-down-right</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-arrow-down"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-arrow-down, <br>icon-im-down</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-arrow-down-left"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-arrow-down-left, <br>icon-im-down-left</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-arrow-left"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-arrow-left, <br>icon-im-left3</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-arrow-up-left2"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-arrow-up-left2, <br>icon-im-up-left2</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-arrow-up2"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-arrow-up2, <br>icon-im-up2</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-arrow-up-right2"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-arrow-up-right2, <br>icon-im-up-right2</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-arrow-right2"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-arrow-right2, <br>icon-im-right4</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-arrow-down-right2"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-arrow-down-right2, <br>icon-im-down-right2</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-arrow-down2"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-arrow-down2, <br>icon-im-down2</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-arrow-down-left2"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-arrow-down-left2, <br>icon-im-down-left2</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-arrow-left2"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-arrow-left2, <br>icon-im-left4</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-circle-up"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-circle-up, <br>icon-im-up3</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-circle-right"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-circle-right, <br>icon-im-right5</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-circle-down"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-circle-down, <br>icon-im-down3</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-circle-left"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-circle-left, <br>icon-im-left5</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-tab"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-tab, <br>icon-im-arrows</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-move-up"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-move-up, <br>icon-im-sort</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-move-down"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-move-down, <br>icon-im-sort2</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-sort-alpha-asc"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-sort-alpha-asc, <br>icon-im-arrange</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-sort-alpha-desc"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-sort-alpha-desc, <br>icon-im-arrange2</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-sort-numeric-asc"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-sort-numeric-asc, <br>icon-im-arrange3</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-sort-numberic-desc"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-sort-numberic-desc, <br>icon-im-arrange4</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-sort-amount-asc"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-sort-amount-asc, <br>icon-im-arrange5</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-sort-amount-desc"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-sort-amount-desc, <br>icon-im-arrange6</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-command"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-command, <br>icon-im-cmd</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-shift"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-shift</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-ctrl"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-ctrl, <br>icon-im-control</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-opt"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-opt, <br>icon-im-option</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-checkbox-checked"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-checkbox-checked, <br>icon-im-checkbox</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-checkbox-unchecked"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-checkbox-unchecked, <br>icon-im-checkbox2</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-radio-checked"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-radio-checked, <br>icon-im-radio-button</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-radio-checked2"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-radio-checked2, <br>icon-im-radio-button2</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-radio-unchecked"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-radio-unchecked, <br>icon-im-radio-button3</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-crop"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-crop, <br>icon-im-resize</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-make-group"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-make-group</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-ungroup"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-ungroup</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-scissors"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-scissors, <br>icon-im-cut</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-filter"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-filter, <br>icon-im-funnel</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-font"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-font, <br>icon-im-typeface</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-ligature"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-ligature, <br>icon-im-typography</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-ligature2"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-ligature2, <br>icon-im-typography2</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-text-height"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-text-height, <br>icon-im-wysiwyg</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-text-width"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-text-width, <br>icon-im-wysiwyg2</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-font-size"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-font-size, <br>icon-im-wysiwyg3</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-bold"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-bold, <br>icon-im-wysiwyg4</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-underline"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-underline, <br>icon-im-wysiwyg5</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-italic"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-italic, <br>icon-im-wysiwyg6</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-strikethrough"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-strikethrough, <br>icon-im-wysiwyg7</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-omega"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-omega, <br>icon-im-wysiwyg8</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-sigma"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-sigma, <br>icon-im-wysiwyg9</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-page-break"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-page-break, <br>icon-im-wysiwyg10</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-superscript"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-superscript, <br>icon-im-wysiwyg11</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-subscript"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-subscript, <br>icon-im-wysiwyg12</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-superscript2"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-superscript2, <br>icon-im-wysiwyg13</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-subscript2"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-subscript2, <br>icon-im-wysiwyg14</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-text-color"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-text-color, <br>icon-im-wysiwyg15</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-pagebreak"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-pagebreak, <br>icon-im-wysiwyg16</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-clear-formatting"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-clear-formatting, <br>icon-im-wysiwyg17</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-table"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-table, <br>icon-im-wysiwyg18</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-table2"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-table2, <br>icon-im-wysiwyg19</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-insert-template"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-insert-template, <br>icon-im-wysiwyg20</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-pilcrow"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-pilcrow, <br>icon-im-wysiwyg21</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-ltr"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-ltr, <br>icon-im-wysiwyg22</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-rtl"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-rtl, <br>icon-im-wysiwyg23</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-section"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-section, <br>icon-im-wysiwyg24</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-paragraph-left"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-paragraph-left, <br>icon-im-wysiwyg25</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-paragraph-center"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-paragraph-center, <br>icon-im-wysiwyg26</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-paragraph-right"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-paragraph-right, <br>icon-im-wysiwyg27</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-paragraph-justify"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-paragraph-justify, <br>icon-im-wysiwyg28</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-indent-increase"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-indent-increase, <br>icon-im-wysiwyg29</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-indent-decrease"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-indent-decrease, <br>icon-im-wysiwyg30</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-share"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-share, <br>icon-im-out</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-new-tab"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-new-tab, <br>icon-im-out2</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-embed"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-embed, <br>icon-im-code</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-embed2"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-embed2, <br>icon-im-code2</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-terminal"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-terminal, <br>icon-im-console</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-share2"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-share2, <br>icon-im-social</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-mail"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-mail2, <br>icon-im-contact2</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-mail2"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-mail3, <br>icon-im-contact3</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-mail3"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-mail4, <br>icon-im-contact4</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-mail4"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-mail5, <br>icon-im-contact5</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-amazon"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-amazon, <br>icon-im-brand</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-google"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-google, <br>icon-im-brand2</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-google2"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-google2, <br>icon-im-brand3</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-google3"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-google3, <br>icon-im-brand4</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-google-plus"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-google-plus, <br>icon-im-brand5</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-google-plus2"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-google-plus2, <br>icon-im-brand6</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-google-plus3"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-google-plus3, <br>icon-im-brand7</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-hangouts"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-hangouts, <br>icon-im-brand8</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-google-drive"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-google-drive, <br>icon-im-brand9</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-facebook"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-facebook, <br>icon-im-brand10</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-facebook2"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-facebook2, <br>icon-im-brand11</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-instagram"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-instagram, <br>icon-im-brand12</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-whatsapp"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-whatsapp, <br>icon-im-brand13</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-spotify"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-spotify, <br>icon-im-brand14</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-telegram"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-telegram, <br>icon-im-brand15</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-twitter"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-twitter, <br>icon-im-brand16</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-vine"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-vine, <br>icon-im-brand17</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-vk"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-vk, <br>icon-im-brand18</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-renren"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-renren, <br>icon-im-brand19</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-sina-weibo"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-sina-weibo, <br>icon-im-brand20</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-rss"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-feed2, <br>icon-im-rss</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-rss2"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-feed3, <br>icon-im-rss2</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-youtube"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-youtube, <br>icon-im-brand21</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-youtube2"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-youtube2, <br>icon-im-brand22</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-twitch"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-twitch, <br>icon-im-brand23</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-vimeo"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-vimeo, <br>icon-im-brand24</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-vimeo2"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-vimeo2, <br>icon-im-brand25</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-lanyrd"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-lanyrd, <br>icon-im-brand26</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-flickr"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-flickr, <br>icon-im-brand27</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-flickr2"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-flickr2, <br>icon-im-brand28</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-flickr3"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-flickr3, <br>icon-im-brand29</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-flickr4"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-flickr4, <br>icon-im-brand30</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-dribbble"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-dribbble, <br>icon-im-brand31</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-behance"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-behance, <br>icon-im-brand32</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-behance2"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-behance2, <br>icon-im-brand33</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-deviantart"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-deviantart, <br>icon-im-brand34</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-500px"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-500px, <br>icon-im-brand35</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-steam"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-steam, <br>icon-im-brand36</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-steam2"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-steam2, <br>icon-im-brand37</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-dropbox"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-dropbox, <br>icon-im-brand38</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-onedrive"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-onedrive, <br>icon-im-brand39</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-github"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-github, <br>icon-im-brand40</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-npm"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-npm, <br>icon-im-brand41</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-basecamp"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-basecamp, <br>icon-im-brand42</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-trello"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-trello, <br>icon-im-brand43</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-wordpress"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-wordpress, <br>icon-im-brand44</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-joomla"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-joomla, <br>icon-im-brand45</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-ello"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-ello, <br>icon-im-brand46</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-blogger"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-blogger, <br>icon-im-brand47</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-blogger2"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-blogger2, <br>icon-im-brand48</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-tumblr"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-tumblr, <br>icon-im-brand49</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-tumblr2"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-tumblr2, <br>icon-im-brand50</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-yahoo"/>
                </div>
                <div class="icon-classname">
                  <span class="unit1">eabb</span>
                  <span>icon-im-yahoo, <br>icon-im-brand51</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-yahoo2"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-yahoo2</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-tux"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-tux, <br>icon-im-brand52</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-appleinc"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-apple, <br>icon-im-brand53</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-finder"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-finder, <br>icon-im-brand54</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-android"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-android, <br>icon-im-brand55</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-windows"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-windows, <br>icon-im-brand56</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-windows8"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-windows8, <br>icon-im-brand57</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-soundcloud"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-soundcloud, <br>icon-im-brand58</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-soundcloud2"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-soundcloud2, <br>icon-im-brand59</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-skype"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-skype, <br>icon-im-brand60</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-reddit"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-reddit, <br>icon-im-brand61</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-hackernews"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-hackernews, <br>icon-im-brand62</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-wikipedia"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-wikipedia, <br>icon-im-brand63</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-linkedin"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-linkedin, <br>icon-im-brand64</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-linkedin2"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-linkedin2, <br>icon-im-brand65</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-lastfm"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-lastfm, <br>icon-im-brand66</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-lastfm2"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-lastfm2, <br>icon-im-brand67</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-delicious"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-delicious, <br>icon-im-brand68</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-stumbleupon"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-stumbleupon, <br>icon-im-brand69</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-stumbleupon2"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-stumbleupon2, <br>icon-im-brand70</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-stackoverflow"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-stackoverflow, <br>icon-im-brand71</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-pinterest"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-pinterest, <br>icon-im-brand72</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-pinterest2"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-pinterest2, <br>icon-im-brand73</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-xing"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-xing, <br>icon-im-brand74</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-xing2"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-xing2, <br>icon-im-brand75</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-flattr"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-flattr, <br>icon-im-brand76</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-foursquare"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-foursquare, <br>icon-im-brand77</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-yelp"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-yelp, <br>icon-im-brand78</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-paypal"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-paypal, <br>icon-im-brand79</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-chrome"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-chrome, <br>icon-im-browser</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-firefox"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-firefox, <br>icon-im-browser2</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-IE"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-IE, <br>icon-im-browser3</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-edge"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-edge, <br>icon-im-browser4</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-safari"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-safari, <br>icon-im-browser5</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-opera"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-opera, <br>icon-im-browser6</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-file-pdf"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-file-pdf, <br>icon-im-file10</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-file-openoffice"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-file-openoffice, <br>icon-im-file11</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-file-word"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-file-word, <br>icon-im-file12</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-file-excel"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-file-excel, <br>icon-im-file13</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-libreoffice"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-libreoffice, <br>icon-im-file14</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-html-five"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-html-five, <br>icon-im-w3c</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-html-five2"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-html-five2, <br>icon-im-w3c2</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-css3"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-css3, <br>icon-im-w3c3</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-git"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-git, <br>icon-im-brand80</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-codepen"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-codepen, <br>icon-im-brand81</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-svg"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-svg</span>
                </div>
              </div>
              <div class="demo-icon">
                <div class="icon-box">
                  <i class="icon-im icon-im-IcoMoon"/>
                </div>
                <div class="icon-classname">
                  <span>icon-im-IcoMoon, <br>icon-im-icomoon</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
require('icomoon-free-npm/Font/IcoMoon-Free.ttf')
</script>



// WEBPACK FOOTER //
// resources/js/views/admin/icons/IcoMoon.vue